export type TSessionExpiredAt = string | null;

export class SessionExpirationService {
  private expiredAt: TSessionExpiredAt = null;
  private storageKey: string = "SessionExpirationIdKey_default";

  constructor(storageKey: string) {
    this.setStorageKey(storageKey);
    this.recover();
  }

  public startExpirationProcess(remainingSeconds: number) {
    this.expiredAt = this.getGeneratedExpiredAt(remainingSeconds);
    this.setExpiredAt(this.expiredAt);
  }

  public stopExpirationProcess() {
    this.expiredAt = null;
    window.sessionStorage.removeItem(this.storageKey);
  }

  public setExpiredAt(expiredAt: TSessionExpiredAt) {
    this.expiredAt = expiredAt;
    if (this.expiredAt) {
      window.sessionStorage.setItem(this.storageKey, this.expiredAt);
    }
  }

  public getExpiredAt(): TSessionExpiredAt {
    return this.expiredAt;
  }

  public isSessionExpired(): boolean {
    const expiredAt = this.getExpiredAt();
    if (!expiredAt) {
      return false;
    }
    return Boolean(Date.now() > Number(expiredAt));
  }

  public getExpiredInSeconds(): number | null {
    const expiredInSeconds = Math.round(( Number(this.expiredAt) - Date.now() ) / 1000);
    if (expiredInSeconds < 0) {
      return null;
    }
    return expiredInSeconds;
  }

  public setStorageKey(storageKey: string): boolean {
    this.storageKey = storageKey;
    return true;
  }

  private recover(): boolean {
    const expiredAtSaved = this.getExpiredAtFromStorage();
    if (!expiredAtSaved) {
      return false;
    }
    this.setExpiredAt(expiredAtSaved);
    return true;
  }

  private getExpiredAtFromStorage(): string | null {
    return window.sessionStorage.getItem(this.storageKey);
  }

  private getGeneratedExpiredAt(remainingSeconds: number): string {
    return String(Date.now() + remainingSeconds * 1000);
  }
}
